import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const CardTimeline = () => {
  return (
    <Container>
      <BackgroundTransForm />
      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
    </Container>
  );
};

CardTimeline.propTypes = {
  // steps: PropTypes.array.isRequired,
  // currentStep: PropTypes.number.isRequired,
};

export default CardTimeline;

const Container = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-self: center;
  /* z-index: -1000px; */
  height: 400px;
  border-radius: 5px;

  -webkit-box-shadow: 10px 12px 30px 0px rgba(204, 204, 204, 1);
  -moz-box-shadow: 10px 12px 30px 0px rgba(204, 204, 204, 1);
  box-shadow: 10px 12px 30px 0px rgba(204, 204, 204, 1);
`;
const BackgroundTransForm = styled.div`
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: red;
  position: absolute;
  z-index: -1000;
  height: 100px;
  width: 100%;
  top: 0px;
  /* top: -250px;
  left: -100px; */

  /* transform: rotate(-10deg); */
`;
